// Every job-market number shown in this funnel lives here, with its source.
// Sources are deliberately not shown on the page. Keep the wording close to the
// source: "may be impacted" must not become "will be lost".

// WEF Future of Jobs 2025
// https://www.eco-business.com/press-releases/future-of-jobs-report-2025-78-million-new-jobs-by-2030-but-urgent-upskilling-needed-to-prepare-workforces
export const EMPLOYERS_REDUCING_PARTS = { percent: 41, big: '41%', rest: 'of employers plan to reduce their workforce as AI automates tasks.' };
export const EMPLOYERS_REDUCING = `${EMPLOYERS_REDUCING_PARTS.big} ${EMPLOYERS_REDUCING_PARTS.rest}`;
export const SKILLS_CHANGING = 'Nearly 40% of the skills required on the job are set to change by 2030.';
export const RESKILLING_PARTS = { count: 59, big: '59 of every 100', rest: 'workers are projected to need reskilling by 2030.' };
export const RESKILLING = `${RESKILLING_PARTS.big} ${RESKILLING_PARTS.rest}`;

// IMF 2024
// https://www.imf.org/en/Blogs/Articles/2024/01/14/ai-will-transform-the-global-economy-lets-make-sure-it-benefits-humanity
export const JOBS_IMPACTED = 'About 60% of jobs in advanced economies may be impacted by AI.';

// PwC 2026 Global AI Jobs Barometer
// https://kyodonewsprwire.jp/release/202606150856
export const AI_WAGE_PREMIUM_PERCENT = 62;
export const AI_WAGE_PREMIUM = `Workers with AI skills earn a ${AI_WAGE_PREMIUM_PERCENT}% wage premium.`;
export const ENTRY_LEVEL_SHRINKING =
  "Since 2019, entry-level roles outside the AI-exposed 'seniorised' group have shrunk 10%.";

// Gallup workforce surveys
// Half and 28% (Q1 2026): https://www.tomshardware.com/tech-industry/artificial-intelligence/half-of-all-us-employees-now-use-artificial-intelligence-at-work-crossing-landmark-threshold-for-first-time-gallup-data-shows-daily-and-weekly-usage-hitting-all-time-high-of-28-percent-in-q1-2026-with-65-percent-feeling-positive-about-its-impact-on-productivity
// 12% (fall 2025): https://wtop.com/national/2026/01/how-americans-are-using-ai-at-work-according-to-a-new-gallup-poll/
export const PEER_LINES = {
  Never: "Half of US workers already use AI at work. You're on the wrong side of that line.",
  'Not often': "28% of US workers use AI at least weekly. You're not in that group yet.",
  'Every week': "28% of US workers use AI at least weekly. Using it isn't an edge anymore. Knowing agents and workflows is.",
  'Every day': "Only about 12% of US workers use AI daily, so you're ahead on usage. Your score shows what you're still missing.",
};
